import axios from "axios";
import { getToken } from "./helpers";
import VLPlayerCore from '@viewlift/player/esm';
import { getEdgeLocation } from "./modules/GameDetailModule/pingToCheck";
import logger from "./logger";
import { setStorageItem } from "./helpers/storageManager";


const getBulkEntitlementData = async () => {
  try {
    let bulkIds = await getBulkEntitlementIds();
    if (localStorage.getItem('mobiEdgeLocationUrl')) {
      localStorage.removeItem('mobiEdgeLocationUrl');
    }

    if (bulkIds?.length > 0) {
      const token = await getToken();
      const edgeLocationUrl = await getEdgeLocation(token) || null;

      if (edgeLocationUrl) {
        localStorage.setItem('mobiEdgeLocationUrl', edgeLocationUrl);
        logger(`APPROPRIATE EDGE LOCATION IS ${edgeLocationUrl}`);
      }

      const res = await axios.get(`${window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl}/v3/entitlement/videos`, {
        headers: {
          Authorization: token,
          'x-api-key': window?.xApiKey
        },
        params: {
          deviceType: 'web_browser',
          contentConsumption: 'web',
          ids: bulkIds.toString()
        }
      });

      const entitlements = res?.data?.entitlements;
      const assetMap = new Map();
      const BulkAssetMap = new Map();
      const bulkContentMap = new Map();

      entitlements?.forEach((ele) => {
        const videoAssets = ele?.video?.streamingInfo?.videoAssets;
        BulkAssetMap.set(ele?.video?.gist?.id, {
          ...videoAssets,
          dash: getUrl(edgeLocationUrl, videoAssets?.dash),
          hls: getUrl(edgeLocationUrl, videoAssets?.hls)
        });

        const { src, type } = VLPlayerCore().getSource(ele, 'sourceonly') || { src: null, type: null };
        assetMap.set(ele?.video?.gist?.id, { src: getUrl(edgeLocationUrl, src), type });
        bulkContentMap.set(ele?.video?.gist?.id, ele);
      });

      setStorageItem("bulkEnitlementMap", { assetMap });
      setStorageItem("BulkAssetMap", BulkAssetMap);
      setStorageItem("bulkContentMap", bulkContentMap);
    }
  } catch (e) {
    logger(`ERROR IN FETCHING BULK ENTITLEMENT DATA ${e}`, "error");
  }
}

const getUrl=(edgeLocationUrl,orignalUrl)=>{
  if(!edgeLocationUrl)
  return orignalUrl;

  else if(orignalUrl?.includes(edgeLocationUrl))
  return orignalUrl;

  else 
  return modifyUrlByEdgeLocation(orignalUrl,edgeLocationUrl)
}

const modifyUrlByEdgeLocation=(src,edgeUrl)=>{
  let url=src?.split('.com');
  let newUrl= edgeUrl + url?.[1];
  return newUrl || src || {};
}

export const getBulkEntitlementIds = async () => {
   const ids = [];
   const holesMappingData = window?.app_data?.appcmsMain?.sportConfig?.championsData?.holesMappingData;
    if (!holesMappingData) return [];
      Object.values(holesMappingData).forEach(hole => {
        if (hole.tee?.id) ids.push(hole.tee.id);
        if (hole.fairway?.id) ids.push(hole.fairway.id);
        if (hole.green?.id) ids.push(hole.green.id);
      });
    
      return ids;

}

export {getBulkEntitlementData, modifyUrlByEdgeLocation, getUrl}